import { TextHeadlineProps } from './TextHeadline'

export type TextHeadlineColorPresetConfig = {
    textColor: string
    outlineColor: string
    dropShadowColor: string
}

export type TextBounds = {
    x: number
    width: number
}

export type TextHeadlineColorPreset = 'orange' | 'blue' | 'red' | 'white' | 'green'

export const textColorPresets: Record<TextHeadlineColorPreset, TextHeadlineColorPresetConfig> = {
    orange: {
        textColor: '#FF8A00',
        outlineColor: '#8A0B00',
        dropShadowColor: '#8A0B00',
    },
    blue: {
        textColor: '#2E86FF',
        outlineColor: '#0A2897',
        dropShadowColor: '#0A2897',
    },
    red: {
        textColor: '#E43D59',
        outlineColor: '#5A000F',
        dropShadowColor: '#5A000F',
    },
    white: {
        textColor: '#FFFFFF',
        outlineColor: '#5486AC',
        dropShadowColor: '#5486AC',
    },
    green: {
        textColor: '#00BD6E',
        outlineColor: '#1F4B0E',
        dropShadowColor: '#1F4B0E',
    },
}

export const fontFamilyByVariant: Record<NonNullable<TextHeadlineProps['fontFamily']>, string> = {
    nunito: 'Nunito, ui-sans-serif, system-ui, sans-serif',
    grandstander: 'Grandstander, ui-sans-serif, system-ui, sans-serif',
}

export function resolveTextColorConfig({
    colorPreset,
    textColor,
}: {
    colorPreset: TextHeadlineProps['colorPreset']
    textColor: string
}) {
    if (colorPreset) {
        return textColorPresets[colorPreset]
    }

    return {
        textColor,
        outlineColor: '#8A0B00',
        dropShadowColor: '#8A0B00',
    }
}

export function splitTextIntoLines(text: string, maxCharsPerLine: number) {
    const words = text.trim().split(/\s+/)
    const lines: string[] = []
    let currentLine = ''

    for (const word of words) {
        const nextLine = currentLine ? `${currentLine} ${word}` : word

        if (nextLine.length > maxCharsPerLine && currentLine) {
            lines.push(currentLine)
            currentLine = word
        } else {
            currentLine = nextLine
        }
    }

    if (currentLine) {
        lines.push(currentLine)
    }

    return lines
}
